import type { LexicalNode, NodeKey, SerializedLexicalNode } from 'lexical';
import type { JSX } from 'react';

import { Box, Flex, Text } from '@mantine/core';
import { $applyNodeReplacement, DecoratorNode } from 'lexical';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export class PageBreakNode extends DecoratorNode<JSX.Element> {
  static getType(): string {
    return 'pagebreak';
  }

  static clone(node: PageBreakNode): PageBreakNode {
    return new PageBreakNode(node.__key);
  }

  static importJSON(): PageBreakNode {
    return $createPageBreakNode();
  }

  constructor(key?: NodeKey) {
    super(key);
  }

  exportJSON(): SerializedLexicalNode {
    return super.exportJSON();
  }

  isInline(): boolean {
    return false;
  }

  createDOM(): HTMLElement {
    return document.createElement('div');
  }

  updateDOM(): false {
    return false;
  }

  decorate(): JSX.Element {
    return (
      <Flex align="center" gap="xs" my="xs">
        <Box flex={1} style={{ borderBottom: '1px dashed var(--mantine-color-gray-5)' }} />
        <Text size="xs" fw={FONT_WEIGHTS.medium} c="gray.5">
          Page
        </Text>
        <Box flex={1} style={{ borderBottom: '1px dashed var(--mantine-color-gray-5)' }} />
      </Flex>
    );
  }
}

export function $createPageBreakNode(): PageBreakNode {
  return $applyNodeReplacement(new PageBreakNode());
}

export function $isPageBreakNode(node: LexicalNode | null | undefined): node is PageBreakNode {
  return node instanceof PageBreakNode;
}
